import { z } from 'zod'

import { FORM_MESSAGES_MAP } from 'Constants/formMessages'

export const prolongInfoStepSchema = z.object({
  terms: z.boolean().refine(data => data === true, {
    message: FORM_MESSAGES_MAP.REQUIRED,
  }),
})
